export const enum RedisCacheStatusEnum {
  UNKNOWN = -1,
  ENABLED = 0,
  DISABLED = 1,
  PENDING_ENABLE = 2,
  PENDING_DISABLE = 3,
}

export interface SyncStatusResult {
  status: RedisCacheStatusEnum;
  websiteId: number;
}

export interface SyncStatusError {
  websiteId: number;
  reason: string;
}

export interface StatusUpdateResult {
  status: RedisCacheStatusEnum;
  websiteId: number;
}

export interface StatusUpdateError {
  currentStatus: RedisCacheStatusEnum;
  websiteId: number;
  reason: string;
}
